import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { CallbackModal } from '../components/CallbackModal';
import { MapPin, Star, Scan, Languages, Calendar, MessageCircle, Phone, CheckCircle2, ArrowRight, Plus, Minus, ShieldCheck, CreditCard, Clock, UserCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
const BOOKING_URL = 'https://denticoclinic.patientportal.onl/bookings';
const WHATSAPP_URL = 'https://wa.me/447345197820';
const TELEGRAM_URL = 'https://t.me/dentico_clinic';
const MAPS_URL = 'https://maps.app.goo.gl/Fhof2j1jnLA3ffqT6';
const MAPS_EMBED_URL = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1241.0181846982155!2d-0.104187760804084!3d51.53089276153758!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760f7c6534e077%3A0xa54a590bd3b2a149!2sDentico%20Clinic%20-%20Private%20Dentist%20in%20Angel%2C%20Islington!5e0!3m2!1suk!2suk!4v1769722166469!5m2!1suk!2suk';
function TelegramIcon({
  className
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} data-id="element-1864">
      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" data-id="element-1865" />
    </svg>;
}
function AccordionItem({
  question,
  answer,
  isOpen,
  onToggle
}: {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}) {
  return <div className="border-b border-gray-100 last:border-b-0" data-id="element-1866">
      <button onClick={onToggle} className="w-full flex items-center justify-between py-4 text-left focus:outline-none group" data-id="element-1867">
        <span className="text-lg font-medium text-gray-900 group-hover:text-teal-600 transition-colors" data-id="element-1868">
          {question}
        </span>
        <span className={`flex-shrink-0 ml-4 w-6 h-6 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-teal-600 text-white' : 'bg-gray-100 text-gray-400'}`} data-id="element-1869">
          {isOpen ? <Minus className="w-4 h-4" data-id="element-1870" /> : <Plus className="w-4 h-4" data-id="element-1871" />}
        </span>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-4' : 'max-h-0 opacity-0'}`} data-id="element-1872">
        <p className="text-gray-600 leading-relaxed" data-id="element-1873">{answer}</p>
      </div>
    </div>;
}
export function ImplantyLondonRuPage() {
  const [isCallbackOpen, setIsCallbackOpen] = useState(false);
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };
  const faqs = [{
    q: 'Сколько стоит имплантация зуба в Лондоне?',
    a: 'Стоимость имплантации зависит от клинической ситуации, типа импланта и необходимости дополнительных процедур (например, костная пластика). После консультации мы составляем прозрачный план лечения и смету.'
  }, {
    q: 'Больно ли ставить имплант?',
    a: 'Процедура проводится под местной анестезией. Во время установки импланта большинство пациентов не чувствуют боли, а после — возможен дискомфорт, который контролируется рекомендациями и обезболиванием.'
  }, {
    q: 'Сколько времени занимает имплантация?',
    a: 'Сроки зависят от случая. Обычно сначала проводится консультация и диагностика, затем установка импланта, а после периода заживления — установка коронки. Точный график определяется индивидуально.'
  }, {
    q: 'Подходит ли имплантация, если зуб давно отсутствует?',
    a: 'Да, но может потребоваться оценка состояния кости. Во время консультации мы проверяем объем кости и при необходимости обсуждаем варианты восстановления.'
  }, {
    q: 'Можно ли поставить имплант за один визит?',
    a: 'Иногда возможна одномоментная установка (immediate loading), но чаще требуется период заживления для интеграции импланта. Это определяется после тщательной диагностики.'
  }, {
    q: 'Какие импланты вы используете?',
    a: 'Мы работаем с проверенными системами имплантов премиум-класса, которые имеют долгосрочную гарантию и высокий процент приживления.'
  }, {
    q: 'Можно ли получить консультацию на русском?',
    a: 'Да, в Dentico Clinic возможно общение на русском языке во время консультации и лечения.'
  }, {
    q: 'Где находится клиника?',
    a: 'Dentico Clinic расположена в Angel / Islington, Central London (EC1V). Адрес: 360–364 City Road, London EC1V 2PY, рядом с Angel Station.'
  }];
  // Schemas
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a
      }
    }))
  };
  const procedureSchema = {
    '@context': 'https://schema.org',
    '@type': 'MedicalProcedure',
    name: 'Dental Implants',
    description: 'Surgical placement of dental implants to replace missing teeth.',
    procedureType: 'http://schema.org/SurgicalProcedure',
    provider: {
      '@type': 'Dentist',
      name: 'Dentico Clinic',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '360-364 City Road',
        addressLocality: 'London',
        postalCode: 'EC1V 2PY',
        addressCountry: 'GB'
      }
    }
  };
  return <Layout data-id="element-1874">
      <CallbackModal isOpen={isCallbackOpen} onClose={() => setIsCallbackOpen(false)} data-id="element-1875" />

      {/* Structured Data */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(faqSchema)
    }} data-id="element-1876" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(procedureSchema)
    }} data-id="element-1877" />

      {/* 1. HERO SECTION */}
      <section className="relative bg-white overflow-hidden" data-id="element-1878">
        <div className="absolute inset-0 bg-teal-50/50 -skew-y-3 origin-top-left transform translate-y-20" data-id="element-1879" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-16 lg:pt-20 lg:pb-24 relative" data-id="element-1880">
          <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-1881">
            <div className="space-y-6" data-id="element-1882">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-teal-100 text-teal-800 text-sm font-medium" data-id="element-1883">
                <span className="relative flex h-2 w-2" data-id="element-1884">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-teal-400 opacity-75" data-id="element-1885"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-teal-500" data-id="element-1886"></span>
                </span>
                Имплантация зубов в Лондоне
              </div>

              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight tracking-tight" data-id="element-1887">
                Имплантация зубов в Лондоне –{' '}
                <span className="text-teal-600" data-id="element-1888">Dentico Clinic</span>
                <br data-id="element-1889" />
                <span className="text-2xl sm:text-3xl font-medium text-gray-500 mt-2 block" data-id="element-1890">
                  (Angel, Islington)
                </span>
              </h1>

              <p className="text-lg text-gray-600 max-w-lg leading-relaxed" data-id="element-1891">
                Восстановление утраченных зубов с помощью современных имплантов.
                Консультация на русском языке, цифровая диагностика и прозрачный
                план лечения.
              </p>

              {/* Trust Badges */}
              <div className="flex flex-wrap gap-3 text-sm font-medium text-gray-700" data-id="element-1892">
                <div className="flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-lg border border-gray-200 shadow-sm" data-id="element-1893">
                  <Star className="w-4 h-4 text-yellow-400 fill-current" data-id="element-1894" />
                  5★ Google Reviews
                </div>
                <div className="flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-lg border border-gray-200 shadow-sm" data-id="element-1895">
                  <MapPin className="w-4 h-4 text-teal-600" data-id="element-1896" />
                  Angel, EC1V
                </div>
                <div className="flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-lg border border-gray-200 shadow-sm" data-id="element-1897">
                  <Languages className="w-4 h-4 text-teal-600" data-id="element-1898" />
                  Русский язык
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-3 pt-4" data-id="element-1899">
                <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-1900">
                  <Button size="lg" className="w-full gap-2 shadow-lg shadow-teal-600/20" data-id="element-1901">
                    <Calendar className="w-5 h-5" data-id="element-1902" />
                    Записаться на консультацию
                  </Button>
                </a>
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-1903">
                  <Button variant="outline" size="lg" className="w-full gap-2 border-teal-200 text-teal-700 hover:bg-teal-50" data-id="element-1904">
                    <MessageCircle className="w-5 h-5 text-green-600" data-id="element-1905" />
                    WhatsApp
                  </Button>
                </a>
              </div>
            </div>

            <div className="relative" data-id="element-1906">
              <div className="absolute inset-0 bg-teal-200 rounded-3xl transform rotate-3 blur-sm opacity-30" data-id="element-1907"></div>
              <img src="https://images.unsplash.com/photo-1606811841689-23dfddce3e95?auto=format&fit=crop&w=1200&q=80" alt="Имплантация зубов - Dentico Clinic London" className="relative rounded-3xl shadow-2xl object-cover h-[300px] sm:h-[400px] lg:h-[500px] w-full" data-id="element-1908" />
            </div>
          </div>
        </div>
      </section>

      {/* 2. WHAT ARE IMPLANTS */}
      <section className="py-16 bg-white" data-id="element-1909">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1910">
          <div className="text-center mb-10" data-id="element-1911">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-1912">
              Что такое дентальная имплантация?
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-1913">
              Дентальная имплантация — это самый современный метод
              восстановления утраченных зубов, который позволяет вернуть не
              только эстетику улыбки, но и полную жевательную функцию. Имплант —
              это титановый корень, который устанавливается в кость челюсти и
              служит надежной опорой для коронки или мостовидного протеза.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed mt-4" data-id="element-1914">
              В отличие от съемных протезов, импланты ощущаются и функционируют
              как собственные зубы. Они предотвращают атрофию костной ткани и не
              требуют обтачивания соседних здоровых зубов, что делает их лучшим
              долгосрочным решением для восстановления зубного ряда.
            </p>
          </div>
        </div>
      </section>

      {/* 3. PROCESS */}
      <section className="py-16 bg-gray-50" data-id="element-1915">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1916">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-1917">
            Этапы имплантации в Dentico Clinic
          </h2>
          <div className="grid md:grid-cols-4 gap-8" data-id="element-1918">
            {[{
            step: '01',
            title: 'Консультация',
            desc: 'Осмотр, 3D-диагностика (КТ) и составление детального плана лечения.'
          }, {
            step: '02',
            title: 'Установка',
            desc: 'Хирургический этап установки импланта под местной анестезией.'
          }, {
            step: '03',
            title: 'Заживление',
            desc: 'Период остеоинтеграции (приживления), который длится от 3 до 6 месяцев.'
          }, {
            step: '04',
            title: 'Протезирование',
            desc: 'Установка постоянной керамической коронки на имплант.'
          }].map((item, idx) => <Card key={idx} className="p-6 relative overflow-hidden" data-id="element-1919">
                <div className="text-6xl font-bold text-teal-50 absolute -top-4 -right-4 select-none" data-id="element-1920">
                  {item.step}
                </div>
                <div className="relative z-10" data-id="element-1921">
                  <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1922">
                    {item.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-1923">{item.desc}</p>
                </div>
              </Card>)}
          </div>
        </div>
      </section>

      {/* 4. WHO NEEDS IMPLANTS */}
      <section className="py-16 bg-white" data-id="element-1924">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1925">
          <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-1926">
            <div data-id="element-1927">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-1928">
                Кому подходит имплантация?
              </h2>
              <ul className="space-y-4" data-id="element-1929">
                {['Отсутствие одного или нескольких зубов', 'Желание отказаться от съемных протезов', 'Разрушение мостовидных конструкций', 'Необходимость восстановления жевательной функции', 'Эстетические дефекты зубного ряда'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-1930">
                    <CheckCircle2 className="w-6 h-6 text-teal-600 flex-shrink-0 mt-0.5" data-id="element-1931" />
                    <span className="text-gray-700 text-lg" data-id="element-1932">{item}</span>
                  </li>)}
              </ul>
              <div className="mt-8" data-id="element-1933">
                <Link to="/ru/contact" data-id="element-1934">
                  <Button size="lg" className="gap-2" data-id="element-1935">
                    <Calendar className="w-5 h-5" data-id="element-1936" />
                    Записаться на консультацию
                  </Button>
                </Link>
              </div>
            </div>
            <div className="relative h-[400px] rounded-2xl overflow-hidden shadow-xl" data-id="element-1937">
              <img src="https://images.unsplash.com/photo-1609840114035-3c981b782dfe?auto=format&fit=crop&w=1200&q=80" alt="Дентальная имплантация процесс" className="absolute inset-0 w-full h-full object-cover" data-id="element-1938" />
            </div>
          </div>
        </div>
      </section>

      {/* 5. BENEFITS */}
      <section className="py-16 bg-teal-50" data-id="element-1939">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1940">
          <div className="text-center mb-12" data-id="element-1941">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-1942">
              Преимущества имплантации в Dentico Clinic
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-1943">
              Мы используем передовые технологии и материалы для наилучшего
              результата.
            </p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1944">
            {[{
            icon: Scan,
            title: 'Цифровое планирование',
            desc: 'Точное 3D-моделирование операции для предсказуемого результата.'
          }, {
            icon: UserCheck,
            title: 'Опытная команда',
            desc: 'Врачи с многолетним опытом в хирургической стоматологии.'
          }, {
            icon: Languages,
            title: 'Русский язык',
            desc: 'Полное понимание и комфортная коммуникация на родном языке.'
          }, {
            icon: ShieldCheck,
            title: 'Гарантия качества',
            desc: 'Используем только сертифицированные импланты мировых брендов.'
          }, {
            icon: Clock,
            title: 'Экономия времени',
            desc: 'Оптимизированные протоколы лечения для вашего комфорта.'
          }, {
            icon: MapPin,
            title: 'Удобная локация',
            desc: 'Центр Лондона, 5 минут от станции метро Angel.'
          }].map((item, idx) => <Card key={idx} className="p-6 bg-white" data-id="element-1945">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center text-teal-600 mb-4" data-id="element-1946">
                  <item.icon className="w-6 h-6" data-id="element-1947" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-1948">
                  {item.title}
                </h3>
                <p className="text-gray-600" data-id="element-1949">{item.desc}</p>
              </Card>)}
          </div>
        </div>
      </section>

      {/* 6. FAQ */}
      <section className="py-16 bg-white" data-id="element-1950">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1951">
          <div className="text-center mb-10" data-id="element-1952">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-1953">
              Частые вопросы об имплантации
            </h2>
          </div>
          <div className="space-y-2" data-id="element-1954">
            {faqs.map((faq, idx) => <AccordionItem key={idx} question={faq.q} answer={faq.a} isOpen={openFaqIndex === idx} onToggle={() => toggleFaq(idx)} data-id="element-1955" />)}
          </div>
        </div>
      </section>

      {/* 7. INTERNAL LINKS */}
      <section className="py-12 bg-gray-50 border-t border-gray-100" data-id="element-1956">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1957">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-1958">
            Смотрите также
          </h2>
          <div className="flex flex-wrap gap-4" data-id="element-1959">
            <Link to="/ru/russkij-stomatolog-london" data-id="element-1960">
              <Button variant="outline" size="sm" data-id="element-1961">
                Русскоязычный стоматолог
              </Button>
            </Link>
            <Link to="/ru/services/crowns" data-id="element-1962">
              <Button variant="outline" size="sm" data-id="element-1963">
                Коронки
              </Button>
            </Link>
            <Link to="/ru/services/hygiene" data-id="element-1964">
              <Button variant="outline" size="sm" data-id="element-1965">
                Гигиена
              </Button>
            </Link>
            <Link to="/ru/prices" data-id="element-1966">
              <Button variant="outline" size="sm" data-id="element-1967">
                Цены
              </Button>
            </Link>
            <Link to="/ru/contact" data-id="element-1968">
              <Button variant="outline" size="sm" data-id="element-1969">
                Контакты
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* 8. CTA */}
      <section className="py-16 bg-teal-900" data-id="element-1970">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-1971">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4" data-id="element-1972">
            Верните себе уверенную улыбку
          </h2>
          <p className="text-xl text-teal-100 mb-8 max-w-2xl mx-auto" data-id="element-1973">
            Запишитесь на консультацию по имплантации сегодня.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-1974">
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-1975">
              <Button size="lg" className="w-full gap-2 bg-white text-teal-900 hover:bg-teal-50" data-id="element-1976">
                <Calendar className="w-5 h-5" data-id="element-1977" />
                Записаться онлайн
              </Button>
            </a>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-1978">
              <Button variant="outline" size="lg" className="w-full gap-2 border-teal-400 text-teal-100 hover:bg-teal-800 hover:text-white" data-id="element-1979">
                <MessageCircle className="w-5 h-5" data-id="element-1980" />
                WhatsApp
              </Button>
            </a>
          </div>
        </div>
      </section>
    </Layout>;
}